var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.998,
    viewBox: "0 0 20 19.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "report1",
    transform: "translate(-79.511 -11.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17282",
    "data-name": "Path 17282",
    d: "M136.659,16.136a.512.512,0,0,0-.14-.323l-4-4a.566.566,0,0,0-.354-.147H118.223a1.53,1.53,0,0,0-1.555,1.5v17a1.53,1.53,0,0,0,1.555,1.5H135.11a1.53,1.53,0,0,0,1.555-1.5c-.006-.031.012-14-.006-14.029Zm-3.993-2.762,2.293,2.293h-2.293Zm2.444,17.291H118.223a.531.531,0,0,1-.556-.5v-17a.531.531,0,0,1,.556-.5h13.443v3.5a.5.5,0,0,0,.5.5h3.5v13.5a.531.531,0,0,1-.556.5Zm-8.943-5.5h-3v-3a.5.5,0,0,0-.5-.5,4,4,0,1,0,4,4,.5.5,0,0,0-.5-.5Zm-3.5,3.5a3,3,0,0,1-.5-5.958v2.958a.5.5,0,0,0,.5.5h2.958a3,3,0,0,1-2.958,2.5Zm1.5-8h0a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5,3.5,3.5,0,0,0-3.5-3.5Zm.5,3v-1.95a2.508,2.508,0,0,1,1.95,1.95Zm-6-5.5a.5.5,0,0,1,.5-.5h11a.5.5,0,0,1,0,1h-11A.5.5,0,0,1,118.668,18.167Zm.5-1.5h11a.5.5,0,0,0,.5-.5v-2a.5.5,0,0,0-.5-.5h-11a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.5.5Zm.5-2h10v1h-10Zm14.5,11h-1.5v-2.5a.5.5,0,0,0-.5-.5h-2a.5.5,0,0,0-.5.5v1.5h-1.5a.5.5,0,0,0-.5.5v4a.5.5,0,0,0,.5.5h6a.5.5,0,0,0,.5-.5v-3a.5.5,0,0,0-.5-.5Zm-5.5,0h1v3h-1Zm2-.5v-1.5h1v5h-1Zm3,3.5h-1v-2h1Z",
    transform: "translate(-37.157)",
    fill: "#bebfb6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport1);
export default __webpack_public_path__ + "static/media/report1.6bc4a33dfaff3166772aaeddc73c69cd.svg";
export { ForwardRef as ReactComponent };